module.exports = __webpack_public_path__ + "img/gplay.7a751e05.jpg";